import type { RouteRecordRaw } from 'vue-router';

import { EnumRoutes } from '@/helpers/enums/routes.enum';

export const financialRoutes: Array<RouteRecordRaw> = [
  {
    path: EnumRoutes.financials.cartPage.path,
    name: EnumRoutes.financials.cartPage.name,
    component: () => import('@/views/financials/CartPage.vue'),
    meta: EnumRoutes.financials.cartPage.meta,
  },
  {
    path: EnumRoutes.financials.myPurchases.path,
    name: EnumRoutes.financials.myPurchases.name,
    component: () => import('@/views/financials/MyPurchasesPage.vue'),
    meta: EnumRoutes.financials.myPurchases.meta,
    children: [
      {
        path: EnumRoutes.financials.myWallet.path,
        name: EnumRoutes.financials.myWallet.name,
        component: () => import('@/views/financials/MyWallet.vue'),
        meta: EnumRoutes.financials.myWallet.meta,
      },
      {
        path: EnumRoutes.financials.paymentHistory.path,
        name: EnumRoutes.financials.paymentHistory.name,
        component: () => import('@/views/financials/PaymentHistory.vue'),
        meta: EnumRoutes.financials.paymentHistory.meta,
      },
    ],
  },
  //order history page

  // single order page
  {
    path: EnumRoutes.financials.singleOrder.path,
    name: EnumRoutes.financials.singleOrder.name,
    component: () => import('@/views/financials/SingleOrder.vue'),
    meta: EnumRoutes.financials.singleOrder.meta,
  },
  {
    path: EnumRoutes.financials.paymentCompleteRedirect.path,
    name: EnumRoutes.financials.paymentCompleteRedirect.name,
    component: () => import('@/views/financials/CompletePaymentRedirect.vue'),
    meta: EnumRoutes.financials.paymentCompleteRedirect.meta,
  },
];
